import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=5672f82f&scoped=true&"
import script from "./Connections.vue?vue&type=script&lang=js&"
export * from "./Connections.vue?vue&type=script&lang=js&"
import style0 from "./Connections.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Connections.vue?vue&type=style&index=1&id=5672f82f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672f82f",
  null
  
)

export default component.exports